export default __webpack_public_path__ + "static/media/elevate.dc1f1c50.jpeg";